import loadable from '@loadable/component';

export type Coords = import('google-map-react').Coords;

export default loadable(() =>
  import(/* webpackChunkName: "GoogleMap" */ './HaGoogleMap'),
);
